import axios from 'axios';

/**
 * Centralized API request utility for Ford API calls.
 * Merges common params (dealer_id, brand_id, country_id, market_id) with any additional params.
 * @param {string} path - API path (e.g. '/api/v1/accessories/123/3d-config')
 * @param {Object} params - Additional query params to merge
 * @returns {Promise<Object>} API response data
 */
export const apiRequest = async (path, params = {}) => {
    const country_id = localStorage.getItem('country_id');
    const dealer_id = localStorage.getItem('dealer_id');
    const brand_id = localStorage.getItem('brand_id') || process.env.REACT_APP_BRAND_ID;
    const market_id = localStorage.getItem('market_id') || '1';
    const token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const locale = localStorage.getItem('language') || 'en';

    const searchParams = new URLSearchParams({
        dealer_id,
        brand_id,
        country_id,
        market_id,
        ...params
    });
    const url = `${process.env.REACT_APP_FORD_API_URL}${path}?${searchParams}`;

    const response = await axios.get(url, {
        headers: { 'Authorization': token, 'X-Locale': locale }
    });
    return response.data;
};

/**
 * POST request to Ford API with body and same auth/query params as apiRequest.
 * @param {string} path - API path (e.g. '/api/v1/accessories/model-variant/cart-counts-by-category')
 * @param {Object} body - Request body
 * @returns {Promise<Object>} API response data
 */
export const apiPost = async (path, body = {}) => {
    const country_id = localStorage.getItem('country_id');
    const dealer_id = localStorage.getItem('dealer_id');
    const brand_id = localStorage.getItem('brand_id') || process.env.REACT_APP_BRAND_ID;
    const market_id = localStorage.getItem('market_id') || '1';
    const token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const locale = localStorage.getItem('language') || 'en';

    const searchParams = new URLSearchParams({
        dealer_id,
        brand_id,
        country_id,
        market_id
    });
    const url = `${process.env.REACT_APP_FORD_API_URL}${path}?${searchParams}`;

    const response = await axios.post(url, body, {
        headers: { 'Authorization': token, 'X-Locale': locale, 'Content-Type': 'application/json' }
    });
    return response.data;
};
